import { JSX, useContext, useMemo } from "react";
import { Text } from "@otrium/atoms";
import { Box } from "@otrium/core";
import { Trans } from "@lingui/macro";
import { Content } from "src/atoms/Content";
import { helpCenterLocaleMap } from "src/utils/locale";
import { AppCtx } from "src/contexts/app.context";

const RRPFootnote = (): JSX.Element => {
  const { locale } = useContext(AppCtx);

  const helpCenterLink = useMemo(
    () =>
      `https://help.otrium.nl/${helpCenterLocaleMap[locale]}/articles/561-on-which-brands-are-promotions-applicable`,
    [locale]
  );

  return (
    <Box backgroundColor="tone.marble" paddingY="space16">
      <Content>
        <Text as="p" textAlign="center">
          *&nbsp;
          <Trans>
            {`Strikethrough price = manufacturer's original recommended retail
            price (RRP) for comparison only. RRP may reflect currency conversion
            rates and excludes shipping & platform fee. The promotions we offer
            on our platform are applicable to many of our brands. See
            participating brands in the `}
            <Text
              as="a"
              textDecoration="underline"
              href={helpCenterLink}
              target="_blank"
              rel="noreferrer"
            >
              Help Centre
            </Text>
            .
          </Trans>
        </Text>
      </Content>
    </Box>
  );
};

export default RRPFootnote;
